import { render, staticRenderFns } from "./ScoreCardPage.vue?vue&type=template&id=67c9d1af&"
import script from "./ScoreCardPage.vue?vue&type=script&lang=js&"
export * from "./ScoreCardPage.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCardPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports